import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
	VerticalTimeline,
	VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/articles.css";
import "./styles/about.css";
import ThemeToggle from "../components/common/themeToggle";
const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "about");
	return (
		<React.Fragment>
			<Helmet>
				<title>{`About Me — ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="articles-logo-container">
						<div className="articles-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="themebuttom-container">
						<div className="theme-button-wrapper">
							<ThemeToggle />
						</div>
					</div>

					<div className="articles-main-container">
						<div className="title articles-title">
							{INFO.about.title}
						</div>

						<div className="subtitle articles-subtitle">
							{INFO.about.description}
						</div>

						<div className="experience-timeline">
							<VerticalTimeline lineColor="#00ADB5">
								{[...INFO.work].reverse().map((item, index) => (
									<VerticalTimelineElement
										key={index}
										className={`vertical-timeline-element--${item.type}`}
										contentStyle={{
											background: item.bgColor,
											color: "#fff",
										}}
										contentArrowStyle={{
											borderRight: `7px solid ${item.bgColor}`,
										}}
										date={item.date}
										iconStyle={{
											background: item.bgColor,
											color: "#fff",
										}}
									>
										<h3 className="vertical-timeline-element-title">
											{item.title}
										</h3>
										<h4 className="vertical-timeline-element-subtitle">
											{item.compnay}
										</h4>
										<p>{item.description}</p>
									</VerticalTimelineElement>
								))}
							</VerticalTimeline>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
